// extracted by mini-css-extract-plugin
export var formContainer = "_i3-0";
export var message = "_i3-1";